export {default as Manual} from './manual'